import type { Ref } from 'vue';
import { computed } from 'vue';
import TwitchLiveStream from '@/components/liveStream/twitchLiveStream/TwitchLiveStream.vue';
import type { UseLiveStreamEvent, UseLiveStreamProvider } from '@/composable/liveStream/useLiveStream';
import { LiveStreamProvider } from '@/interface/enum';

export function useTwitchStream(event: Ref<UseLiveStreamEvent | null>): UseLiveStreamProvider {
    const isAvailable = computed(() => !!(event.value?.stream?.videoUrl?.includes('player.twitch.tv')));
    const isPlayable = computed(() => isAvailable.value);

    const streamDisplay = computed(() => {
        if (!isPlayable.value || !event.value?.stream?.videoUrl) return null;
        return {
            provider: LiveStreamProvider.Twitch,
            component: TwitchLiveStream,
            key: event.value.stream.videoUrl,
            props: {
                videoUrl: event.value.stream.videoUrl,
            },
        };
    });

    return {
        isAvailable,
        isPlayable,
        streamDisplay,
    };
}
